<div class="col-md-12">
    <mat-checkbox [(ngModel)]="filterOwnerOnly"
                  (change)="setFilterOwnerOnly($event.checked)">
      Vis kun mit udstyr
    </mat-checkbox>
    <div class="form-group">
        <label>Filtrér efter kategori</label>
        <select class="form-control form-control-sm col-md-4" [(ngModel)]="filterCategory" (change)="updateFilter()">
            <option [ngValue]="0">Alle kategorier</option>
            <option *ngFor="let cat of categories" [ngValue]="+cat['id']">{{cat['name']}}</option>
        </select>
    </div>
</div>
<div class="col-md-12">
    <table class="table">
        <thead>
            <tr>
                <th scope="col" style="width: 200px">
                    
                </th>
                <th scope="col">Betegnelse</th>
                <th scope="col">Postnr</th>
                <th scope="col">Kategori</th>
                <th scope="col">Første mulige lånedato</th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody *ngIf="poolFiltered">
            <tr *ngFor="let row of poolFiltered">
                <td>
                    <div *ngIf="row['image_filename'] != ''">
                        <!--<img (click)="showFullImage(row['image_filename'])" class="imgThumb" [src]="'assets/images/thumbnails/'+row['image_filename']">-->
                        <a [routerLink]="['/showgear', row['id']]"><img class="imgThumb" [src]="'assets/images/thumbnails/'+row['image_filename']"> </a>
                    </div>
                </td>
                <td>
                    <a [routerLink]="['/showgear', row['id']]">
                        {{row['betegnelse']}}
                    </a>
                </td>
                <td>
                    {{row['postnr']}}
                </td>
                <td>
                    {{categoriesObj[row['category_id']]['name']}}
                </td>
                <td>
                    <!--<span *ngIf="row['currentStatus'] == 'ledig'" class="alert alert-success">Ledig</span>
                    <span *ngIf="row['currentStatus'] == 'reserveret'" class="alert alert-warning">Reserveret</span>
                    <span *ngIf="row['currentStatus'] == 'udlaant'" class="alert alert-danger">Udlånt</span>
                    <span *ngIf="row['currentStatus'] == 'bruges'" class="alert alert-danger">Bruges</span>-->
                    {{row['firstAvailableDate']}}
                </td>
                <td>
                    <div class="btn-group float-right" *ngIf="+row['user_id'] == userId">
                        <button class="btn btn-sm btn-info" (click)="openEditGearDialog(+row['id'])">Rediger</button>
                        <button class="btn btn-sm btn-danger" (click)="deleteGear(+row['id'])">Slet</button>
                    </div> 
                </td>
            </tr>
        </tbody>
    </table>
    <div style="margin-bottom: 35px">
        <button class="btn btn-primary float-right" (click)="openAddGearDialog()">Tilføj udstyr</button>

    </div>
</div>
